import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  InputGroup,
} from 'reactstrap';
import { ENTER_KEY_NAME } from '@mm/constants/keys-codes';
import TextInput from '../../../../../common/components/TextInput';
import '../PageOverviewPane/PageOverviewPane.scss';
import '../../../../../common/scss/input.scss';
import updateListener from '../../../../../common/helpers/utils/EventListenerUtils';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import '../../../../../../src/editor/features/build/components/modals/Modal.scss';

export default class PageGroupEditor extends Component {
  static propTypes = {
    pageGroup: PropTypes.object,
    closeModal: PropTypes.func.isRequired,
    onCreateGroup: PropTypes.func.isRequired,
    onUpdateGroup: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    pageGroup: { name: '' },
  };

  constructor(props) {
    super();

    this.state = {
      pageGroup: props.pageGroup || { name: '' },
    };
  }

  onPageGroupEditorKeyDown = e => {
    if (e.key === ENTER_KEY_NAME) {
      const { pageGroup } = this.state;
      if (pageGroup.id && !this.isNameBlank()) {
        this.onUpdateGroup();
        e.preventDefault();
      } else if (!this.isNameBlank()) {
        this.onCreateGroup();
        e.preventDefault();
      }
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      props: { showModal },
      onPageGroupEditorKeyDown,
    } = this;
    updateListener(
      nextProps.showModal,
      showModal,
      'keydown',
      onPageGroupEditorKeyDown,
    );
    this.setState({
      pageGroup: nextProps.pageGroup || { name: '' },
    });
  }

  onChangeGroup = e => {
    this.setState({
      pageGroup: {
        ...this.state.pageGroup,
        name: e.target.value,
      },
    });
  };

  setRef = node => {
    this.pageGroupNameInput = node;
  };

  setFocus = () => {
    if (this.pageGroupNameInput) {
      this.pageGroupNameInput.focus();
    }
  };

  isNameBlank = () => this.state.pageGroup.name.trim() === '';

  onCreateGroup = () => {
    this.props.onCreateGroup(this.state.pageGroup);
    this.props.closeModal();
  };

  onUpdateGroup = () => {
    this.props.onUpdateGroup(this.state.pageGroup);
    this.props.closeModal();
  };

  renderUpdateButton = () => (
    <Button small onClick={this.onUpdateGroup} disabled={this.isNameBlank()}>
      Edit Folder
    </Button>
  );

  renderCreateButton = () => (
    <Button small onClick={this.onCreateGroup} disabled={this.isNameBlank()}>
      <i className="fa fa-plus-circle fa-lg warning" /> Create Folder
    </Button>
  );

  render() {
    const { pageGroup } = this.state;
    const { setRef, setFocus } = this;
    return (
      <Modal
        onOpened={setFocus}
        isOpen={this.props.showModal}
        toggle={this.props.closeModal}
        className="modal-component"
      >
        <ModalHeader toggle={this.props.closeModal}>
          <h3>{pageGroup.id ? 'Edit Folder' : 'Create Folder'}</h3>
        </ModalHeader>
        <ModalBody>
          <InputGroup className="mb-3 chatbot__input-group page-overview__text-input">
            <TextInput
              inputRef={setRef}
              value={pageGroup.name}
              onChange={this.onChangeGroup}
              placeholder="Enter folder name"
              maxLength="50"
            />
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button red small invert onClick={this.props.closeModal}>
            Cancel
          </Button>
          {pageGroup.id ? this.renderUpdateButton() : this.renderCreateButton()}
        </ModalFooter>
      </Modal>
    );
  }
}
